import { defineAsyncComponent } from "vue";
import { getI18n, registerEntityEndpoint } from "@editor/ui-utils";
const de = {
  ctaButtonApi: {
    createAlreadyExists: "CTA Button kann nicht erstellt werden, da bereits ein CTA Button mit diesem Namen existiert",
    updateAlreadyExists: "CTA Button kann nicht aktualisiert werden, da bereits ein CTA Button mit diesem Namen existiert",
    created: "CTA Button erstellt",
    updated: "CTA Button aktualisiert",
    notFound: "CTA Button nicht gefunden",
    requiredFields: "Sie können den CTA Button nicht speichern, da obligatorische Informationen fehlen"
  },
  ctaButtonList: {
    newButton: "Neuer CTA-Button",
    name: "Nach Button-Text, -Link oder -ID suchen",
    deleteCtaButton: "Löschen",
    loading: "Laden CTA Button",
    label: "Button-Text",
    link: "Button-Link",
    headerCreatedAt: "Erstelldatum",
    headerChangedAt: "Geändert am",
    dpDelete: "Löschen",
    dpDuplicate: "Duplizieren",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    errorOnDeleting: "Error on deleting",
    createCtaButton: "CTA-Button erstellen"
  },
  ctaButton: {
    selectorPlaceholder: "CTA-Button auswählen",
    label: "Button-Text",
    backButton: "Zurück zur CTA Button-Liste",
    newCtaButton: "Neuer CTA-Button",
    messageDeleteCtaButton: "CTA Button löschen",
    messageDeleteCtaButtonTitle: "Bist du sicher, dass du diesen CTA Button löschen möchtest? Er wird aktuell in Artikeln verwendet",
    deleteCtaButton: "Löschen",
    messageDeleted: "CTA Button gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des CTA Buttons",
    errorFailedLoadedCtaButtonWithId: "Es gab einen Fehler beim Abrufen des CTA Buttons",
    handledInLegacySystem: "Dieser CTA Button wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten",
    imageLicenseWarningBanner: "Die Bildlizenz ist für den ausgewählten Artikel nicht gültig",
    isSticky: "Als sticky CTA Button anzeigen",
    stickyButtonWarning: "Entschuldigung, du kannst in einem Artikel maximal einen sticky CTA Button hinzufügen.",
    contentBlockLabel: "CTA-Button"
  },
  ctaButtonEdit: {
    ctaButtonPrimaryType: "Standard",
    ctaButtonPrimaryTypeTooltip: "Standardfarbe für nicht-kommerzielle Zwecke wie z.B. interne Verlinkungen",
    ctaButtonCommercialType: "Werblich",
    ctaButtonCommercialTypeTooltip: "Buttonfarbe für kommerzielle Zwecke wie z.B. Shop-Verlinkungen",
    label: "Button-text",
    link: "Button-link",
    markAffiliate: "Als Affiliate markieren",
    layoutSelection: "Layout",
    buttonImageSelectorDescription: "Bild auswählen oder hochladen (optional)",
    imageSection: "Bild",
    backButton: "Zurück zur CTA Button-Liste",
    editCtaButton: "CTA Button bearbeiten",
    messageSaved: "Deine Änderungen wurden gespeichert. Um den CTA Button in einem Artikel anzuzeigen, füge ihn im gewünschten Artikel hinzu."
  }
};
const en = {
  ctaButtonApi: {
    createAlreadyExists: "Can't create CTA Button because another CTA Button with this name already exists",
    updateAlreadyExists: "Can't update CTA Button because another CTA Button with this name already exists",
    created: "CTA Button created",
    updated: "CTA Button updated",
    notFound: "CTA Button not found",
    requiredFields: "You can't save the CTA Button because mandatory information is missing"
  },
  ctaButtonList: {
    newButton: "New CTA Button",
    name: "Search by button text, link or ID",
    deleteCtaButton: "Delete",
    loading: "Loading CTA Button",
    label: "Button Text",
    link: "Button Link",
    headerCreatedAt: "Creation date",
    headerChangedAt: "Changed at",
    dpDelete: "Delete",
    dpDuplicate: "Duplicate",
    dpEdit: "Edit",
    dpView: "View",
    errorOnDeleting: "Error on deleting",
    createCtaButton: "Create CTA Button"
  },
  ctaButton: {
    selectorPlaceholder: "Select CTA Button",
    label: "Button Text",
    backButton: "Back to CTA Button list",
    newCtaButton: "New CTA Button",
    messageDeleteCtaButton: "Delete CTA Button",
    messageDeleteCtaButtonTitle: "Are you sure you want to delete this CTA button? It is currently being used in articles",
    deleteCtaButton: "Delete",
    messageDeleted: "CTA Button Deleted",
    errorOnDeleting: "There was an error deleting the CTA Button ",
    errorFailedLoadedCtaButtonWithId: "There was an error getting the CTA Button",
    handledInLegacySystem: "This CTA Button is being handled in {source}, you can't edit it on Vibe",
    imageLicenseWarningBanner: "Image license is not valid for selected article",
    isSticky: "Show as sticky CTA button",
    stickyButtonWarning: "Sorry, you can only add one sticky CTA button to an article.",
    contentBlockLabel: "CTA Button"
  },
  ctaButtonEdit: {
    ctaButtonPrimaryType: "Primary",
    ctaButtonPrimaryTypeTooltip: "Primary color for non-commercial purposes as e.g. internal links",
    ctaButtonCommercialType: "Commercial",
    ctaButtonCommercialTypeTooltip: "Button color for commercial purposes as e.g. shop links",
    label: "Button text",
    link: "Button link",
    markAffiliate: "Mark as affiliate",
    layoutSelection: "Layout selection",
    buttonImageSelectorDescription: "Select or upload image (optional)",
    imageSection: "Image",
    backButton: "Back to CTA Button list",
    editCtaButton: "Edit CTA Button",
    messageSaved: "Your changes have been saved. To display the CTA button in an article, add it to the desired article."
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/cta-button",
    children: [
      {
        path: "",
        name: "cta_button_list",
        component: () => import("./cta-button-list.view-TWmW8STs.js"),
        meta: { requiredRight: "navigate_list_cta_button" }
      },
      {
        path: "new",
        name: "cta_button_new",
        component: () => import("./cta-button-edit.view-DO5ymp2m.js"),
        props: () => ({
          title: getI18n().t("ctaButton.newCtaButton"),
          backRoute: "/cta-button"
        }),
        meta: { requiredRight: ["navigate_cta_button"] }
      },
      {
        path: ":id",
        name: "cta_button_detail",
        component: () => import("./cta-button-edit.view-DO5ymp2m.js"),
        props: (route) => ({
          title: getI18n().t("ctaButtonEdit.editCtaButton"),
          id: route.params.id,
          backRoute: "/cta-button"
        }),
        meta: { requiredRight: ["navigate_cta_button"] }
      }
    ]
  }
];
const entityEndpoint = "cta-button";
const CtaButtonService = registerEntityEndpoint(entityEndpoint);
const { getEntity, listEntities, putEntity, postEntity, deleteEntity } = CtaButtonService;
const getCtaButton = async (id) => {
  return getEntity(id);
};
const postCtaButton = async (ctaButton) => {
  return postEntity(ctaButton);
};
const putCtaButton = async (id, ctaButton) => {
  return putEntity(id, ctaButton);
};
const deleteCtaButton = async (id) => {
  return deleteEntity(id);
};
const getEmptyCtaButton = () => ({
  label: "",
  link: "",
  layoutType: "primary",
  hasAffiliate: false,
  legacy: {
    source: "vibe",
    isEditableInCTF: true,
    isRenderedByCTF: true,
    hasBeenModifiedInCTF: true
  }
});
const CtaButtonContentBlock = defineAsyncComponent(() => import("./cta-button-content-block-jc5JuPwH.js"));
const ctaButtonModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "CTA_BUTTON",
      label: "ctaButton.contentBlockLabel",
      icon: "cta",
      component: CtaButtonContentBlock,
      defaultValue: { type: "CTA_BUTTON" }
    }
  ]
};
export {
  CtaButtonService as C,
  getCtaButton as a,
  postCtaButton as b,
  CtaButtonContentBlock as c,
  deleteCtaButton as d,
  ctaButtonModule as e,
  getEmptyCtaButton as g,
  putCtaButton as p
};
//# sourceMappingURL=index-CTHOW249.js.map
